import { formatDate } from '@angular/common';
import { Component, DoCheck, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { IDocumentToSync, ISaleOrderSearch } from 'src/app/models';
import { DocumentStatus } from 'src/app/models/constantes';
import { BaseResponse, IDocumentsToSyncReponse } from 'src/app/models/responses';
import { AlertService, CommonService, SalesManService } from 'src/app/services';
import { DocumentsToSyncService } from 'src/app/services/documents-to-sync.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-offline',
  templateUrl: './offline.component.html',
  styleUrls: ['./offline.component.scss']
})
export class OfflineComponent implements OnInit, OnDestroy {
  //VARBOX
  syncUpAttemps: number;
  codeError: string;
  detailError: string;
  SlpsList: any[] = []; // lista de los vendedores
  @BlockUI() blockUI: NgBlockUI;
  documents: IDocumentToSync[];
  searchForm: FormGroup;
  previewForm: FormGroup;
  permisos: boolean = true;
  page = 1;
  pageSize = 10;
  collectionSize: number;
  model: any;
  constructor(
    private documentsToSyncService: DocumentsToSyncService
    , private alertService: AlertService
    , private smService: SalesManService
    , private commonService: CommonService

  ) { }
  ngOnDestroy(): void {
    this.commonService.offlineInformation.next(``);
  }

  ngOnInit() {
    this.resetPreviewForm();
    this.InitVariables();
    this.requestData();
  }

  InitVariables(): void {
    this.documents = [];
    const mDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.searchForm = new FormGroup({
      fini: new FormControl(mDate, [Validators.required]),
      ffin: new FormControl(mDate, [Validators.required]),
      docStatus: new FormControl('')
    }); // La definicion del formularioFormGroup;
  }

  requestData() {
    this.search();
    this.getSalesMan();
  }

  DownloadData(): void {
    swal({
      type: 'warning',
      title: '¿ Desea descargar la información?',
      text: '',
      showCancelButton: true,
      confirmButtonColor: '#049F0C',
      cancelButtonColor: '#ff0000',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(next => {
      if (!(Object.keys(next)[0] === 'dismiss')) {
        this.blockUI.start(`Descargando la información necesaria, este proceso puede tomar mucho tiempo`);
        this.documentsToSyncService.DownloadData().subscribe(next => {
          this.blockUI.stop();
          console.log(next);
          if (next.result) {
            this.alertService.successAlert(`Descarga de información completada`);
          }
          else {
            console.log(next);
            this.alertService.errorAlert(`Error al descargar la información ${next.errorInfo.Message}`);
          }
        }, error => {
          this.blockUI.stop();
          console.log(error);
          this.alertService.errorAlert(`Error descargar la información ${error}`);
        });
      }
    }, (dismiss) => {
    });
  }

  SyncUp(): void {
    swal({
      type: 'warning',
      title: '¿ Desea sincronizar los documentos ?',
      text: '',
      showCancelButton: true,
      confirmButtonColor: '#049F0C',
      cancelButtonColor: '#ff0000',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(next => {
      if (!(Object.keys(next)[0] === 'dismiss')) {
        this.blockUI.start(`Sincronizando documentos`);
        this.documentsToSyncService.SyncUpDocuments(this.documents.filter(x => x.IsOnSyncUp)).subscribe(next => {
          this.blockUI.stop();
          this.search();
          if (next.result) {
            this.alertService.successAlert(`Sincronización de documentos completada`);
          }
          else {
            console.log(next);
            this.alertService.infoAlert(`No se puedieron sincronizar los documentos: ${next.errorInfo.Message}`);
          }
        }, error => {
          this.blockUI.stop();
          console.log(error);
          this.alertService.errorAlert(`Error sincronizar los documentos ${error}`);
        });
      }
    }, (dismiss) => {
    });
  }

  search(): void {
    let SEARCH = this.searchForm.value as ISaleOrderSearch;
    SEARCH.docStatus = this.searchForm.value.docStatus;
    this.blockUI.start(`Obteniendo documentos`);
    this.documents = [];
    this.documentsToSyncService.GetDocumentsToSync(SEARCH.docStatus, SEARCH.fini, SEARCH.ffin).subscribe(next => {
      this.blockUI.stop();
      if (next.result) {
        this.collectionSize = next.DocumentsToSync.length;
        this.documents = next.DocumentsToSync.map((so, i) => ({ id: i + 1, ...so }));
        this.documents.filter(x => x.DocumentStatus === 'SYNCHRONIZED').forEach(x => x.IsOnSyncUp = false);

        let errorsCounter = 0;
        let pendingCounter = 0;
        let syncupCounter = 0;

        this.documents.forEach(x => {
          switch (x.DocumentStatus) {
            case 'ERROR_ON_SYNCUP':
              errorsCounter++;
              break;
            case 'PENDING_TO_SYNUP':
              pendingCounter++;
              break;
            case 'SYNCHRONIZED':
              syncupCounter++;
          }
        });

        this.commonService.offlineInformation.next(`Sincronizados: ${syncupCounter} Pendientes: ${pendingCounter} Errores: ${errorsCounter}`);
      }
      else {
        console.log(next);
        this.alertService.infoAlert(`No se pudieron obtener los documentos, detalle: ${next.errorInfo.Message}`);
      }
    }, error => {
        this.blockUI.stop();
        console.log(error);
        this.alertService.errorAlert(`No se pudieron obtener los documentos, detalle: ${error}`);
    }, () => {
      this.blockUI.stop();
    });
  }

  isNumber(value: string | number): boolean {
    return ((value != null) && (value !== '') && !isNaN(Number(value.toString())));
  }

  preview(_id: number): void {
    this.resetPreviewForm();
    const DOCUMENT = this.documents.find(x => x.Id === _id);
    this.model = JSON.parse(DOCUMENT.ParsedDocument);
    const mDate = formatDate(DOCUMENT.CreationDate, 'yyyy-MM-dd', 'en');
    this.model.DocDate = mDate;
    this.model.DocNum = DOCUMENT.DocEntry;
    this.model.SalesMan = this.SlpsList.find(x => x.SlpCode === this.model.SalesMan).SlpName;
    let docTotal = 0;
    this.model.SaleOrderLinesList.forEach(line => {
      docTotal += (((line.UnitPrice * line.Quantity) - ((line.UnitPrice * line.Quantity) * line.Discount / 100)) + ((line.UnitPrice * line.Quantity) - ((line.UnitPrice * line.Quantity) * line.Discount / 100)) * line.TaxRate / 100);
    });
    this.model.DocTotal = docTotal;
    this.previewForm.patchValue({ ...this.model });
    (<HTMLButtonElement>document.getElementById('previewTrigger')).click();
  }

  showErrorDetail(_id: number): void {
    const DOCUMENT = this.documents.find(x => x.Id === _id);
    const ERROR = JSON.parse(DOCUMENT.ParsedApiResponse) as BaseResponse;

    if (ERROR && ERROR.errorInfo) {
      this.detailError = ERROR.errorInfo.Message;
      this.codeError = ERROR.errorInfo.Code.toString();
      this.syncUpAttemps = DOCUMENT.SyncUpAttempts;
    }
    else {
      this.detailError = 'Detalle no disponible';
      this.codeError = 'Código no disponible'
      this.syncUpAttemps
    }
    (<HTMLButtonElement>document.getElementById('errorTrigger')).click();
  }

  setForget(_id: number): void {//setForget
    let SELECT = (<HTMLInputElement>document.getElementById(`cb${_id}`));
    this.documents.find(x => x.Id === _id).IsOnSyncUp = SELECT.checked;
  }

  toggleSelects(): void {
    let SELECT = (<HTMLInputElement>document.getElementById('mainToggle'));
    console.log(SELECT.checked);
    this.documents.filter(x => x.DocumentStatus !== 'SYNCHRONIZED').forEach(x => x.IsOnSyncUp = SELECT.checked);
  }

  resetPreviewForm(): void {
    this.previewForm = new FormGroup({
      CardName: new FormControl(''),
      DocDate: new FormControl(''),
      DocNum: new FormControl(''),
      SalesMan: new FormControl(''),
      DocTotal: new FormControl(''),
    }); // La definicion del formularioFormGroup;
  }

  public parsedStatus(_docStatus: number): string {
    return DocumentStatus[_docStatus];
  }

  getSalesMan() {
    this.smService.getSalesMan()
      .subscribe((data: any) => {
        if (data.result) {
          this.SlpsList = data.salesManList;
        }
      }, (error: any) => {
        this.alertService.errorInfoAlert(`Error al intentar conectar con el servidor, Error: ${error}`);
      });
  }
}
